import $ from 'jquery';
import flickity from 'flickity';

import 'flickity-as-nav-for';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';

import FancyboxCarousel from './custom/fancyboxCarousel';
import CarouselObserver from './custom/carouselObserver';

$('.carousel').each(function() {
    var carousel = $(this),
        carouselOptions = {
            arrowShape: 'M.289 48.333c.385-.416.385-.833.77-1.25l23.099-25c1.54-1.666 3.85-1.666 5.39 0a4.26 4.26 0 010 5.834L12.993 45.833H96.15c2.31 0 3.85 1.667 3.85 4.167s-1.54 4.167-3.85 4.167H12.993l16.555 17.916a4.26 4.26 0 010 5.834c-.77.833-1.925 1.25-2.695 1.25-.77 0-1.925-.417-2.695-1.25l-23.1-25c-.384-.417-.77-.834-.77-1.25-.384-1.25-.384-2.084 0-3.334z',
            cellSelector: '.carousel__slide',
            imagesLoaded: false,
            pageDots: false,
            prevNextButtons: false,
            initialIndex: '.is-initial-select',
        };

    // Thumb carousels
    if(carousel.is('[data-flickity-as-nav-for]')) {
        $.extend(true, carouselOptions, {
            asNavFor: carousel.data('flickity-as-nav-for'),
            contain: true,
            pageDots: false,
            prevNextButtons: false
        });
    }

    // Button carousels
    if (carousel.hasClass('carousel--buttons')) {
        $.extend(true, carouselOptions, {
            prevNextButtons: true,
        });
    }

    // Page dots carousels
    if (carousel.hasClass('carousel--page-dots')) {
        $.extend(true, carouselOptions, {
            pageDots: true,
        });
    }

    // Wrap around carousels
    if (carousel.hasClass('carousel--wrap-around')) {
        $.extend(true, carouselOptions, {
            wrapAround: true,
        });
    }

    // Cell align carousels
    if (carousel.hasClass('carousel--cell-align-left')) {
        $.extend(true, carouselOptions, {
            cellAlign: 'left',
        });
    }

    if (carousel.hasClass('carousel--cell-align-center')) {
        $.extend(true, carouselOptions, {
            cellAlign: 'center',
        });
    }

    // Contain carousels
    if (carousel.hasClass('carousel--contain')) {
        $.extend(true, carouselOptions, {
            contain: true,
        });
    }

    // Watch css carousels
    if (carousel.hasClass('carousel--watch-css')) {
        $.extend(true, carouselOptions, {
            watchCSS: true,
        });
    }

    // Instantiate
    const flkty = new flickity(this, carouselOptions);

    if (carousel.hasClass('carousel--fancybox')) {
        new FancyboxCarousel(this, flkty);
    }

    if (carousel.hasClass('carousel--observed')) {
        new CarouselObserver(this);
    }
});
